import { render, staticRenderFns } from "./Entregas.vue?vue&type=template&id=e536dcd8"
import script from "./Entregas.vue?vue&type=script&lang=js"
export * from "./Entregas.vue?vue&type=script&lang=js"
import style0 from "./Entregas.vue?vue&type=style&index=0&id=e536dcd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports